import { environment } from "../environments/environment";

// =============================
// MSAL (Microsoft Authentication Library) Configuration
// =============================
export const msalConfig = {
  auth: {
    // Application (client) ID from Azure AD  AD App Name: Sky-Cognos-SPA
    clientId: '4ae6d352-21cb-4495-a790-b3bb114e215e',

    // Azure AD authority URL (tenant-specific)
    authority: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237',

    // Redirect URI after authentication

    // Use this for production:
    redirectUri: environment.appUrl /*Angular UI endpoint URL*/

    // Use this for local development:
    //redirectUri: 'http://localhost:4200/' 
  },
  cache: {

    // Cache location for tokens and authentication state
    cacheLocation: 'localStorage',

    // Store authentication state in cookies (recommended for IE11/Edge)
    storeAuthStateInCookie: true,
  },
};

// ⭐ ADD THIS PART
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "offline_access"
  ]
};

// =============================
// Protected API Resources Configuration
// =============================
export const protectedResources = {
  functionApi: {

    /* API endpoint for file operations */
    // Use this for production:
    endpoint: environment.apiUrl, /*Function app endpoint URL*/

    // Use this for local development:
    //endpoint: 'http://localhost:7028/api',

    // Required scopes for API access, AD App Name: Sky-Cognos-API
    scopes: [
      'api://8c349cc1-6d5a-4b87-935c-f3c19e2a0d92/access_as_user'
    ]
  },
};
